module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("beHSG"))).then(() => module.bundle.root('5erN3'));